import { PlatformSlug } from 'constants/consts'
import { enabledOn, isFeatureAvailable } from 'platformConfig'

export const PRACTICE_RESULTS_CONFIG = enabledOn(PlatformSlug.CasperBooster)

export const isPracticeResultsAvailable = (slug?: PlatformSlug) => isFeatureAvailable(PRACTICE_RESULTS_CONFIG, slug)
